export default {"src":"/_next/static/media/Phone.a0e481d6.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};